// extracted by mini-css-extract-plugin
module.exports = {"confirmed":"Cards_confirmed__iMMyf","recovered":"Cards_recovered__1aizD","deaths":"Cards_deaths__Qdjzq","container":"Cards_container__3bjn6","recorvered":"Cards_recorvered__pIC_g"};